// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "specialist-261105-15/static/css/" + chunkId + "." + {"831":"583e16c7","854":"36854e5e","997":"755557fe"}[chunkId] + ".chunk.css";
};